import _ from 'lodash';

import {
  buildEntityActions,
  buildEntityApi,
  buildEntitySelectors,
  entityUtils,
} from '@zapier/toolbox-redux-framework';

// Onboarding
export const type = 'onboarding';

export const api = buildEntityApi(
  type,
  '/api/v4/onboardings',
  onboardingAPI => {
    const { loadCollection } = onboardingAPI;

    onboardingAPI.loadCollection = (...args) =>
      loadCollection(...args).catch(
        _.partial(entityUtils.remove401StatusFromGetErrorResponse, type)
      );
  },
  {
    ensureTrailingSlash: true,
  }
);

export const selectors = buildEntitySelectors(type);
export const actions = buildEntityActions(type, selectors, api);
